<template>
  <div class="feedback-display">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <search-form
            ref="searchform"
            :showDates="true"
            :results="feedback"
            :noResults="'No feedback found for selected period.'"
            :options="{
              permalink: 'getFeedback'
            }">
          </search-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SearchForm from '@/components/SearchForm'
  import { mapGetters } from 'vuex'
  export default {
    name: 'FeedbackDisplay',
    components: {
      SearchForm
    },
    computed: {
      ...mapGetters([
        'feedback'
      ])
    },
    data () {
      return {
        autoReloadTimer: ''
      }
    },
    mounted () {
      this.autoReloadTimer = setInterval(this.autoReload, 30000)
    },
    beforeDestroy () {
      clearInterval(this.autoReloadTimer)
    },
    methods: {
      autoReload () {
        this.$refs.searchform.refresh()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/admin/FeedbackDisplay.vue